/**
 *
 * @param jsonBlob
 * @param filename
 */

export const exportJson = (response: any, filename: string) => {
  const jsonBlob = new Blob([JSON.stringify(response)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(jsonBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.json`;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
